<script setup lang="ts">
import ActionButton from '@/components/buttons/ActionButton.vue';
import { useModalStore } from '@/features/overlays/modals/modalStore';

const modalStore = useModalStore();
</script>

<template>
  <ActionButton
    class="focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
    @click="() => modalStore.toggle('invitation')"
    v-bind="$attrs"
  >
    {{ $t('navigation.candidate.invite_button') }}
  </ActionButton>
</template>
